import React, { useState, useEffect } from "react";

const testimonials = [
  {
    name: "Ravi Sharma",
    feedback:
      "The sofa set I bought is very strong and looks premium. Perfect for Indian homes.",
    rating: 5,
  },
  {
    name: "Priya Mehta",
    feedback:
      "Beautiful design and solid wood quality. My family really loved the dining table.",
    rating: 4,
  },
  {
    name: "Arjun Nair",
    feedback:
      "Delivery was on time, and the craftsmanship is truly world-class.",
    rating: 5,
  },
  {
    name: "Neha Kapoor",
    feedback:
      "The finishing and polish are excellent. It has completely changed the look of my living room.",
    rating: 4,
  },
  {
    name: "Vikram Singh",
    feedback:
      "Very durable and traditional style furniture. Reminds me of classic Indian furniture designs.",
    rating: 5,
  },
  {
    name: "Ananya Iyer",
    feedback:
      "Loved the minimalist design. It blends well with modern Indian interiors.",
    rating: 4,
  },
];

const renderStars = (count) => (
  <div className="stars text-warning mb-2">
    {Array.from({ length: 5 }, (_, i) => (
      <span key={i}>{i < count ? "★" : "☆"}</span>
    ))}
  </div>
);

const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

const TestimonialSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  // Dynamically chunk size based on isMobile
  const testimonialGroups = chunkArray(testimonials, isMobile ? 1 : 3);

  useEffect(() => {
    // Load Tagembed widget script dynamically
    const script = document.createElement("script");
    script.src = "https://widget.tagembed.com/embed.min.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="testimonial-section py-0 py-md-5 bg-light">
      <div className="container">
        <h3 className="text-center mb-4 fw-bold">What Our Clients Say</h3>

        {/* Tagembed Widget */}
        <div
          className="tagembed-widget"
          style={{ width: "100%", height: "100%", overflow: "auto" }}
          data-widget-id="295448"
          data-website="1"
        ></div>
      </div>
    </section>
  );
};

export default TestimonialSection;